import { useEffect, useRef, useState } from '../../common/common';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { useErrorContext } from '../../context/ErrorContext';
import useNavigation from '../../common/useNavigation';
import { validateAddCategoryForm } from '../../validation/Authentication/Validation.js';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation';
const MidAddCategory = (type) => {
    
    const { navigateDashboard } = Navigations();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [values, setValue] = useState({
        CategoryName: "",
        fileImage: null,
    });
    const fileInputRef = useRef(null);

    useEffect(() => {
        showToast('', '');
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);
    const logUserData = () => {
        // console.log({ users: users });
        if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
            // console.log({usertypeArray:usertypeArray});

            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);

            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) {
            }
            else {
                navigateDashboard('buyer');
            }
        }
    };

    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddCategoryForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setValue(prevValues => ({ ...prevValues, [name]: value }));

        // console.log({ values: values });
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();

    };
    const handleFileChange = ({ target: { files } }) => {
        setValue(prevValues => ({ ...prevValues, fileImage: files[0] }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        // StartLoading(setisLoading);
        const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors });
        if (Object.keys(validationErrors).length === 0) {
            StopLoading(setisLoading)
            clearAllErrors();
            SubmitCategory();
        }
    };

    const SubmitCategory = async () => {
        StartLoading(setisLoading);

        const { CategoryName, fileImage } = values;

        if (!CategoryName) {
            StopLoading(setisLoading);
            showToast('Please fill all required fields', 'error');
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
        if (fileImage && !allowedTypes.includes(fileImage.type)) {
            StopLoading(setisLoading);
            showToast("Only JPG, PNG, and GIF images are allowed", 'error');
            return;
        }
        const maxSize = 2 * 1024 * 1024;
        if (fileImage && fileImage.size > maxSize) {
            StopLoading(setisLoading);
            showToast("Image size must be less than 2MB", 'error');
            return;
        }

        try {
            const formData = new FormData();
            formData.append("CategoryName", CategoryName.trim());
            formData.append("parentID", "0");
            formData.append("app", "0");

            if (fileImage) {
                formData.append("fileImage", fileImage);
            }

            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/AddCategories`,
                formData,
                { withCredentials: true }
            );

            StopLoading(setisLoading);

            if (response.data.success === 1) {
                showToast(response.data.message, 'success');
                values.CategoryName = "";
                values.fileImage = "";
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            } else {
                showToast(response.data.message, 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);

            if (err.response && err.response.data) {
                const { message, success } = err.response.data;

                if (success !== undefined && message) {
                    showToast(message, 'error');
                } else if (err.response.status === 401) {
                    // logout();
                } else {
                    showToast("Failed to Add Category, please try again later", 'error');
                }
            } else if (err.message) {
                showToast(err.message, 'error');
            } else {
                showToast("Something went wrong. Please try again.", 'error');
            }
        }
    };



    // const SubmitCategory = async () => {
    //     StartLoading(setisLoading);

    //     const { CategoryName, fileImage } = values;
    //     // console.log('CategoryName' + CategoryName);
    //     // console.log('fileImage' + fileImage);





    //     if (!CategoryName) {
    //         StopLoading(setisLoading);
    //         showToast('Please fill all required fields', 'error');
    //         return;
    //     }

    //     try {
    //         // Create FormData and append all fields
    //         const formData = new FormData();

    //         formData.append("CategoryName", CategoryName);
    //         formData.append("parentID", "0"); // Ensure string value if backend expects string
    //         formData.append("app", "0"); // Ensure string value if backend expects string
    //         if (fileImage) {
    //             formData.append("fileImage", fileImage);
    //         }

    //         // Log the FormData content
    //         for (let [key, value] of formData.entries()) {
    //             // console.log(key, value);
    //         }
    //         // Send the request - pass formData directly as the body
    //         const response = await axiosJWT.post(
    //             `${process.env.REACT_APP_API_URL}/api/AddCategories`,
    //             formData, // Send formData directly, don't wrap it
    //             {
    //                 withCredentials: true,
    //                 // Don't set Content-Type header manually - Axios will set it automatically
    //                 // with the correct boundary for FormData
    //             }
    //         );

    //         StopLoading(setisLoading);
    //         if (response.data.success === 1) {
    //             showToast(response.data.message, 'success');
    //             values.CategoryName = "";
    //             values.fileImage = "";
    //             if (fileInputRef.current) {
    //                 fileInputRef.current.value = ""; // Clear the file input
    //             }
    //         } else {
    //             showToast(response.data.message, 'error');
    //         }
    //     } catch (err) {
    //         StopLoading(setisLoading);
    //         if (err.response) {
    //             const res_status = err.response.data.success;
    //             const res_message = err.response.data.message;

    //             if (res_status !== undefined && res_message !== undefined) {
    //                 showToast(res_message, 'error');
    //             } else if (err.response.status === 401) {
    //                 // logout();
    //             } else {
    //                 showToast("Failed to Add Category, please try again later", 'error');
    //             }
    //         } else {
    //             showToast(err.response.message, 'error');
    //         }
    //     }
    // };
    // const SubmitCategory = async () => {
    //     StartLoading(setisLoading);
    //     const { CategoryName, fileImage } = values;

    //     // const data = { CategoryName, fileImage };
    //     var formData = new FormData();
    //     formData.append("CategoryName", CategoryName);
    //     formData.append("parentID", 0);
    //     formData.append("app", 0);
    //     if (fileImage) { formData.append("fileImage", fileImage); }


    //     if (!CategoryName) {
    //         StopLoading(setisLoading)
    //         showToast('Please fill all required fields', 'error');
    //         return;
    //     }
    //     try {
    //         await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/AddCategories`, {formData,app:0}, { headers: {
    //             'Content-Type': 'multipart/form-data'
    //         }, withCredentials: true, })
    //             .then((response) => {
    //                 StopLoading(setisLoading);
    //                 if (response.data.success === 1) {

    //                     showToast(response.data.message, 'success');
    //                     values.CategoryName = "";
    //                     values.fileImage = "";
    //                     if (fileInputRef.current) {
    //                         fileInputRef.current.value = ""; // Clear the file input
    //                     }
    //                 }
    //                 else {

    //                     showToast(response.data.message, 'error');
    //                 }
    //             })
    //             .catch((err) => {
    //                 const res_status = err.response.data.success;
    //                 const res_message = err.response.data.message;
    //                 if (res_status !== "" && res_message !== "") { }
    //                 else if (err.status === 401) {
    //                     // logout();
    //                 }
    //                 else {
    //                     showToast(err.data.message, 'error');
    //                 }
    //             });
    //     } catch (err) {
    //         StopLoading(setisLoading);
    //         showToast("Failed, please try again later ", 'error');
    //     }
    // };
    return { values, users,userPlan,Remainuser,subUser, handleChange, handleFileChange, handleSubmit, isLoading }
}
export default MidAddCategory